import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

interface TeacherThemeCtx {
  dm: boolean;
  toggleDarkMode: () => void;
}

const TeacherThemeContext = createContext<TeacherThemeCtx>({
  dm: false,
  toggleDarkMode: () => {},
});

export function TeacherThemeProvider({ children }: { children: ReactNode }) {
  const [dm, setDm] = useState(() => localStorage.getItem('teacherDarkMode') === 'true');

  useEffect(() => {
    localStorage.setItem('teacherDarkMode', String(dm));
  }, [dm]);

  return (
    <TeacherThemeContext.Provider value={{ dm, toggleDarkMode: () => setDm(d => !d) }}>
      {children}
    </TeacherThemeContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTeacherTheme(): TeacherThemeCtx {
  return useContext(TeacherThemeContext);
}
